import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=2a379f1a"
import script from "./test1.vue?vue&type=script&lang=js"
export * from "./test1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports